import React from 'react';
import { ProjectCard } from './ProjectCard';
import { Row } from "react-bootstrap";
import mern from "../assets/mern-img/mern.png";

export const ProjectMern = () => {
  const mernProjects = [
    {
      title: "React Blog",
      description: "Upcoming MERN project: Blog with React frontend, Node.js backend, and MongoDB database.",
      imgUrl: mern,
      demoLink: "https://blogspace-reactweb.netlify.app/",
      gitLink: "https://github.com/Rajashree0316/React-Blog-Website",
      tech: ["react", "js" ,"mongodb","postman"]
    }
  ];
  return (
    <Row>
      {mernProjects.map((proj, idx) => <ProjectCard key={idx} {...proj} />)}
    </Row>
  )
}
